export default __webpack_public_path__ + "static/jason-3f1c023eba6e9863db289ecb7e825d77.jpg";